import { Clock3, Layers3, ShieldCheck, Sparkles, UserRoundCheck } from "lucide-react";
import type { AuthSessionView, Role } from "@ubisafe/shared";

interface HomePageProps {
  session: AuthSessionView;
}

const roleLabels: Record<Role, string> = {
  ADMIN: "Administrador",
  PRE_IMPLEMENTATION: "Pré-implantação",
  FINANCE: "Financeiro",
};

export function HomePage({ session }: HomePageProps) {
  return (
    <div className="page-stack">
      <section className="page-heading page-heading--welcome">
        <div>
          <span className="eyebrow eyebrow--dark">Gestão de Tenants</span>
          <h1>Olá, {session.user.name.split(" ")[0]}.</h1>
          <p>Clientes, POCs, Trial, classificação e conectividade permanecem disponíveis conforme as permissões do seu perfil. A limpeza de POCs agora é orientada por etapas, com confirmação, progresso persistente e decisões auditadas.</p>
        </div>
        <div className="version-pill"><Sparkles aria-hidden="true" /> Versão 0.9.0 — limpeza orientada</div>
      </section>

      <section className="summary-grid" aria-label="Resumo da conta">
        <article className="summary-card summary-card--primary">
          <div className="summary-card__icon"><ShieldCheck aria-hidden="true" /></div>
          <div>
            <span>Estado do acesso</span>
            <strong>Protegido</strong>
            <small>HTTPS, sessão persistente e autorização por perfil</small>
          </div>
        </article>
        <article className="summary-card">
          <div className="summary-card__icon"><UserRoundCheck aria-hidden="true" /></div>
          <div>
            <span>Perfis ativos</span>
            <strong>{session.user.roles.length}</strong>
            <small>{session.user.roles.map((role) => roleLabels[role]).join(" • ")}</small>
          </div>
        </article>
        <article className="summary-card">
          <div className="summary-card__icon"><Clock3 aria-hidden="true" /></div>
          <div>
            <span>Sessão</span>
            <strong>24 horas</strong>
            <small>Expira em {new Date(session.expiresAt).toLocaleString("pt-BR")}</small>
          </div>
        </article>
      </section>

      <section className="content-card roadmap-card">
        <div className="content-card__heading">
          <div>
            <span className="eyebrow eyebrow--dark">Construção incremental</span>
            <h2>Evolução planejada</h2>
          </div>
          <Layers3 aria-hidden="true" />
        </div>
        <div className="roadmap-list">
          <div className="roadmap-item"><span>0.4</span><div><strong>POCs e Trial</strong><small>Concluído com gestão operacional e linha do tempo</small></div></div>
          <div className="roadmap-item"><span>0.5.1</span><div><strong>Contenção segura</strong><small>Simulador identificado, bloqueado e CUSTOMER02 reparado</small></div></div>
          <div className="roadmap-item"><span>0.8</span><div><strong>Experiência e acesso</strong><small>Cards ampliados, cabeçalhos fixos e Financeiro em modo somente leitura</small></div></div>
          <div className="roadmap-item roadmap-item--next"><span>0.9</span><div><strong>Limpeza orientada</strong><small>Confirmação por etapa, progresso persistente, decisões por registro e conclusão auditada</small></div></div>
        </div>
      </section>
    </div>
  );
}
